import router from '@/router'
import api from '@/api'
import cookies from 'js-cookie'

router.beforeEach((to, from, next) => {
    console.log(1);
    if(to.meta.title){
        document.title = to.meta.title
    }
    if (to.path == '/login' || to.path == '/consume/commentorder' || to.path == '/skin/share') {
        next();
    }else if (to.path == '/auth') {

        console.log(from);
        let code = to.query.code
        getAuthWechatUserInfo(code,next);
    }else{
        console.log(to.path);
        console.log(location.href.split('#')[1]);
        var customer = cookies.get('customer');
        if (customer == undefined && customer == null) {
            var customerCode = to.query.customercode;
            if(customerCode != null && customerCode != undefined){
searchCustomer(customerCode ,next);
            }else{

            }
            // if(to.path != '/home'){
            //     cookies.set('from',location.href.split('#')[1]);
            // }
            
            // verifyWechatUserInfo();
        } else {
            console.log('aaaaaaa');
            next();
        }
    }
})

function verifyWechatUserInfo() {
    var wechatUserInfo = cookies.getJSON('wechatuserinfo');
    console.log(wechatUserInfo);

    if (wechatUserInfo == undefined || wechatUserInfo == null) {
        var redirect = 'http://' + location.host + '/#/auth';
        var targetUrl = 'http://api.store.opentmh.com/wechat/auth/applyauth?appkey=wxccde569fb0bdcf86&type=2&redirect=' + encodeURIComponent(redirect);
        window.location.replace(targetUrl);
    } else {
        searchUserInfo(wechatUserInfo.openid);
        console.log(wechatUserInfo.openid);
    }
}

function getAuthWechatUserInfo(code) {
    api.wechat.auth.getAuthWechatUserInfo('wxccde569fb0bdcf86', code).then(function (res) {
        if (res.data.success) {
            cookies.set('wechatuserinfo', res.data.result);
            searchUserInfo( res.data.result.openid);
        } else {
            next();
        }
    });
}
function searchUserInfo(openId) {
    api.wechat.userinfo.searchUserInfo(openId,1).then(function (res) {
        console.log(res);
        if (res.data.success) {
            searchCustomer(res.data.result.userinfo.customercode);
        }else{
            router.replace({ path: '/login' });
        }
    })
}

function searchCustomer(code ,next) {
    api.customer.customer.searchCustomer(code).then(function (res) {
        if (res.data.success) {
            cookies.set('customer', res.data.result.customer);
            next();
            // router.push({ path: '/home' });
            // var from = cookies.get('from');
            // if(from == undefined){
            //     router.push({ path: '/home' });
            // }else{
            //     cookies.remove('from');
            //     router.push({ path: from });
            // }
            
        } else {
            var wechatUserInfo = cookies.getJSON('wechatuserinfo');
            if (wechatUserInfo == undefined || wechatUserInfo == null) {
                var redirect = 'http://' + location.host + '/#/visableauth';
                var targetUrl = 'http://api.store.idaojia.net/wechat/auth/applyauth?appkey=wx615c79017a61bd63&type=2&redirect=' + encodeURIComponent(redirect);
                location.href = targetUrl;
            } else {
                router.replace({ path: '/login' });
            }
        }
    })
}


// WEBPACK FOOTER //
// ./src/config/filterRouter.js